import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import Axios from 'axios'
import { List } from 'react-content-loader'
import cachios from 'cachios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter'
import calender from '../assets/Event/calendar.png'
import location from '../assets/Event/location.png'
import pdficon from '../assets/pdf.png'
import play from "../assets/Event/play.png"
import eventpdf from '../assets/Event/download.png'
import eventvideo from '../assets/Event/play.png'
import grey from '../assets/homeevent.jpeg'
import Archive from './archive';
import home from '../assets/Home/home.png'
import togglearrow from '../assets/Home/togglearrow.png'
import crumbarrow from '../assets/Home/right.png'
import downarrow from '../assets/newHome/chevron-down.png'
import search from '../assets/search.png'
import pageleft from '../assets/Home/pageleft.png'
import pagenoleft from '../assets/Home/pagenoleft.png'
import pagenoright from '../assets/Home/pagenoright.png'
import pageright from '../assets/Home/pageright.png'
import "./event.css"

class Events extends Component {
  constructor(props) {
    super(props);
    this.state = {
      size: 10,
      tab: props.match.params.id === 'past' ? 1 : 2,
      eventpast: '',
      eventup: '',
      offset: 0,
      offsetpast: 0,
      prev: false,
      next: false,
      prevpast: false,
      nextpast: false,
      search: '',
      txt: 'Loading....',
      event_purpose: ""
    }
  }
  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  handlePageClick(data, search) {
    console.log('search', search)
    if (data === 'next' && this.state.next === true) {
      this.setState({
        eventup: '',
      })
      this.apicallup(this.state.offset + this.state.size, search)
      this.setState({
        offset: this.state.offset + this.state.size
      })

    }
    else if (data === 'prev' && this.state.prev === true) {
      this.setState({
        eventup: '',
      })
      this.setState({
        offset: this.state.offset - this.state.size
      })
      this.apicallup(this.state.offset - this.state.size, search)
    }
    else if (data === 'nextpast' && this.state.nextpast === true) {
      this.setState({
        eventpast: '',
      })
      this.setState({
        offsetpast: this.state.offsetpast + this.state.size
      })
      this.apicallpast(this.state.offsetpast + this.state.size)
    }
    else if (data === 'prevpast' && this.state.prevpast === true) {
      this.setState({
        eventpast: '',
      })
      this.setState({
        offsetpast: this.state.offsetpast - this.state.size
      })
      this.apicallpast(this.state.offsetpast - this.state.size)
    }
  }

  apicallpast(id) {
    localStorage.removeItem('pagenum')
    this.setState({
      pastevents: ''
    })

    if (id <= 0) {
      this.setState({
        prevpast: false,
      })
    }
    else {
      this.setState({
        prevpast: true
      })
    }
    console.log("filters", this.state.event_type, this.state.event_purpose, this.state.event_format, this.state.year)
    const search = localStorage.getItem('search')
    let cf = id + this.state.size
    let filter1 = this.state.event_type ? "&filter[field_event_type.name]=" + this.state.event_type : ""
    let filter2 = this.state.event_purpose ? "&filter[field_purpose_of_event.value]=" + this.state.event_purpose : ""
    let filter3 = this.state.event_format ? "&filter[field_event_format.name]=" + this.state.event_format : ""
    let filter4 = this.state.year ? "&filter[year][condition][path]=field_date&filter[year][condition][operator]=CONTAINS&filter[year][condition][value]=" + this.state.year : ""
    let filters = `${this.state.event_type ? filter1 : ''}${this.state.event_purpose ? filter2 : ''}${this.state.event_format ? filter3 : ''}${this.state.year ? filter4 : ''}`

    const basicn = BASE + `jsonapi/node/events?include=field_image,field_pdf,field_event_report&filter[name][condition][path]=field_date&filter[name][condition][value]=${date}&filter[name][condition][operator]=<&page[offset]=` + cf + '&page[limit]=' + this.state.size + '&sort[sort-author][path]=field_date&sort[sort-author][direction]=DESC'
    const urln = search ? `&filter[title][condition][path]=title&filter[title][condition][value]=${search}&filter[title][condition][operator]=CONTAINS` : ''
    const mains = basicn.concat(urln)
    const mainn = mains.concat(filters)
    //to check Next page
    Axios(mainn, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then((data) => {
        console.log(data.data, 'next')
        //HIDE/SHOW  NEXT button
        if (data.data.data.length === 0) {
          this.setState({
            nextpast: false,
          })
        }
        else {
          this.setState({
            nextpast: true
          })
        }
      })
    let current_datetime = new Date()
    let date = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate()
    console.log('new date get', date)
    const basic = BASE + `jsonapi/node/events?include=field_image,field_pdf,field_event_report&filter[name][condition][path]=field_date&filter[name][condition][value]=${date}&filter[name][condition][operator]=<&page[offset]=` + id + '&page[limit]=' + this.state.size + '&sort[sort-author][path]=field_date&sort[sort-author][direction]=DESC'
    const url = search ? `&filter[title][condition][path]=title&filter[title][condition][value]=${search}&filter[title][condition][operator]=CONTAINS` : ''
    const mained = basic.concat(url)
    const main = mained.concat(filters)
    console.log('pasturl', main)

    Axios.get(main, {
      ttl: 500 /* seconds */,
    })
      .then((data) => {
        console.log(data.data.data, 'past events')
        let past = [], i, date = new Date()
        for (i = 0; i < data.data.data.length; i++) {
          let curdate = new Date(data.data.data[i].attributes.field_date)
          if (curdate.getTime() < date.getTime()) {
            past.push(data.data.data[i])
          }
        }
        this.setState({
          pastevents: past,
          include: data.data.included,
          pastcount: data.data.meta ? data.data.meta.count : ""
        }, () => {
          let i, earray = [], uarray = []
          for (i = 0; i < this.state.pastevents.length; i++) {
            let date = new Date()
            let curdate = new Date(this.state.pastevents[i].attributes.field_date)
            if (curdate.getTime() < date.getTime()) {
              let item = { id: this.state.pastevents[i].attributes.drupal_internal__nid, title: this.state.pastevents[i].attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-") }
              earray.push(item)
            }
            else {
              console.log("uarray data",)
              let item = { id: this.state.pastevents[i].attributes.drupal_internal__nid, title: this.state.pastevents[i].attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-") }
              uarray.push(item)
            }
          }
          localStorage.setItem('earray', JSON.stringify(earray))
        })
        this.topFunction();
      })
      .catch((err) => {
        console.log('not found')
      })

  }


  apicallup(id, search) {
    localStorage.removeItem('pagenum')
    this.setState({
      upevents: ''
    })

    if (id <= 0) {
      this.setState({
        prev: false,
      })
    }
    else {
      this.setState({
        prev: true
      })
    }
    let cf = id + this.state.size
    //to check Next page
    Axios(BASE + 'jsonapi/node/events?include=field_image,field_pdf,field_event_report&page[offset]=' + cf + '&page[limit]=' + this.state.size + '&sort[sort-author][path]=field_date&sort[sort-author][direction]=DESC', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then((data) => {
        console.log(data.data, 'next')
        //HIDE/SHOW  NEXT button
        if (data.data.data) {
          this.setState({
            next: false,
          })
        }
        // else {
        //   this.setState({
        //     next: true
        //   })
        // }
      })
    let filter1 = this.state.event_type ? "&filter[field_event_type.name]=" + this.state.event_type : ""
    let filter2 = this.state.event_purpose ? "&filter[field_purpose_of_event.value]=" + this.state.event_purpose : ""
    let filter3 = this.state.event_format ? "&filter[field_event_format.name]=" + this.state.event_format : ""
    let filter4 = this.state.year ? "&filter[year][condition][path]=field_date&filter[year][condition][operator]=CONTAINS&filter[year][condition][value]=" + this.state.year : ""
    let filters = `${this.state.event_type ? filter1 : ''}${this.state.event_purpose ? filter2 : ''}${this.state.event_format ? filter3 : ''}${this.state.year ? filter4 : ''}`

    const basic = BASE + 'jsonapi/node/events?include=field_image,field_pdf,field_event_report&page[offset]=' + id + '&page[limit]=' + this.state.size + '&sort=-field_date'
    const url = search ? `&filter[title][condition][path]=title&filter[title][condition][value]=${search}&filter[title][condition][operator]=CONTAINS` : ''
    const mained = basic.concat(url)
    const main = mained.concat(filters)
    cachios.get(main, {
      ttl: 500 /* seconds */,
    })
      .then((data) => {
        if (localStorage.getItem('token'))
          this.checkexpiry()
        let i, upcoming = [], date = new Date(), uarray = []
        for (i = 0; i < data.data.data.length; i++) {
          let curdate = new Date(data.data.data[i].attributes.field_date)
          if (curdate.getTime() > date.getTime()) {
            upcoming.push(data.data.data[i])
          }
        }
        this.setState({
          upevents: upcoming.reverse(),
          upinclude: data.data.included
        }, () => {
          for (i = 0; i < this.state.upevents.length; i++) {
            let date = new Date()
            let curdate = new Date(this.state.upevents[i].attributes.field_date)
            if (curdate.getTime() < date.getTime()) {

            }
            else {
              console.log("uarray data", this.state.upevents[i])
              let item = { id: this.state.upevents[i].attributes.drupal_internal__nid, title: this.state.upevents[i].attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-") }
              uarray.push(item)
            }
          }
        })
        localStorage.setItem('uarray', JSON.stringify(uarray))
        console.log(data.data, 'upcoming')
        this.topFunction();
      })
      .catch((err) => {
        console.log('not found', err)
      })

  }
  _handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.apicallpast(this.state.offsetpast, this.state.search)
    }
  }
  setFilter(data) {
    if (!data)
      localStorage.setItem('search', null)
    localStorage.setItem('search', data)
    this.setState({
      search: data,
      pastevents: '',
      offsetpast: 0
    }, () => {
      this.apicallpast(this.state.offsetpast, this.state.search)
      this.apicallup(this.state.offset, this.state.search)
    })
    Axios.get(BASE + `jsonapi/node/events?include=field_image,field_pdf,field_event_report&filter[name][condition][path]=field_date&filter[name][condition][value]=2021-05-28&filter[name][condition][operator]=<&sort[sort-author][path]=field_date&sort[sort-author][direction]=DESC&filter[title][condition][path]=title&filter[title][condition][value]=${data}&filter[title][condition][operator]=CONTAINS`)
      .then((data) => console.log('searchfilt', data.data.data))
  }
  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    // window.location.href = '/'

  }


  refreshexp() {
    let s = new Date();
    s.setSeconds(s.getSeconds() + 1800);
    localStorage.setItem('expiryref', s)
  }


  checkexpiry() {
    if (localStorage.getItem('expiryref')) {
      let expref = Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if (s > expref) {
        this.signout()
      }
      else {
        this.refreshexp()
      }

    }
    else {
      this.signout()
    }
  }




  componentWillReceiveProps(nextProps) {
    if (localStorage.getItem('token'))
      this.checkexpiry()
    this.setState({
      tab: nextProps.match.params.id === 'past' ? 1 : 2
    })
  }
  componentDidMount() {
    Axios.get(`${BASE}jsonapi/taxonomy_term/events_type`)
      .then((type) => {
        console.log("types of event", type.data.data)
        this.setState({
          types: type.data.data
        })
      })
      .catch(err => {
        console.log("error on types", err)
      })
    Axios.get(`${BASE}jsonapi/taxonomy_term/event_format`)
      .then((type) => {
        console.log("types of event", type.data.data)
        this.setState({
          event_format_list: type.data.data
        })
      })
      .catch(err => {
        console.log("error on types", err)
      })
    Axios.get(`${BASE}api/event.json`)
      .then((type) => {
        console.log("types of event", type.data.data)
        this.setState({
          othertypes: type.data.data
        })
      })
      .catch(err => {
        console.log("error on types", err)
      })
    console.log("page mount is calling")
    let page = this.props.match.params.page
    if (page) {
      console.log("page no is", page)
      if (this.props.match.params.id == "past")
        this.setState({
          offsetpast: (page * 10) - 10
        }, () => {
          this.apicallpast(this.state.offsetpast)
          console.log("api calling past")
        })
      else if (this.props.match.params.id == "upcoming")
        this.setState({
          offset: (page * 10) - 10
        }, () => {
          this.apicallup()
        })
    }
    else {
      this.apicallpast(0)
      this.apicallup(0)
    }
  }
  componentWillMount() {
    let page = this.props.match.params.page
    console.log("page detected", page)
    localStorage.removeItem('search')
    let id = this.props.match.params.id
    this.setState({
      tab: this.props.match.params.id === "past" ? 1 : 2
    })
    if (this.props.match.params.id !== "past")
      this.props.history.push('/events/upcoming')
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("prevState", prevState)
    let page = this.props.match.params.page
    if (this.state.offsetpast !== prevState.offsetpast || this.state.offset !== prevState.offset) {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
      if (page) {
        if (this.state.tab === 1) {
          let offset = (this.state.offsetpast / 10) + 1
          this.props.history.push("/events/past/" + offset)
        }
        if (this.state.tab === 2) {
          let offset = (this.state.offset / 10) + 1
          this.props.history.push("/events/completed/" + offset)
        }
      }
      else {
        if (this.state.tab === 1) {
          let offset = (this.state.offsetpast / 10) + 1
          this.props.history.push("/events/past/" + offset)
        }
        if (this.state.tab === 2) {
          let offset = (this.state.offset / 10) + 1

          this.props.history.push("/events/completed/" + offset)
        }
      }
    }

    if (prevState.tab !== this.state.tab) {
      if (page) {
        if (this.state.tab === 1) {
          this.props.history.push("/events/past/" + page)
        }
        if (this.state.tab === 2) {
          this.props.history.push("/events/upcoming/" + page)
        }
      }
      else {
        if (this.state.tab === 1) {
          this.props.history.push("/events/past")
        }
        if (this.state.tab === 2) {
          this.props.history.push("/events/upcoming")
        }
      }
    }
  }
  addFilter(type, value) {
    this.setState({
      offsetpast: 0,
      upevents: "",
      pastevents: ""
    })
    if (type == "event_purpose") {
      let length = (6.5 * value.length) + 60
      this.setState({
        purpose_length: length
      })
    }
    if (type == "event_type") {
      let length = (6.5 * value.length) + 50
      this.setState({
        type_length: length
      })
    }
    console.log("filter adding")
    this.setState({
      [type]: value
    }, () => {
      this.apicallpast(this.state.offsetpast)
      this.apicallup(this.state.offset)
    })
  }

  goto(add) {
    this.props.history.push(add)
  }
  render() {
    return (
      <div className="evntlist">
        <div className='page-events'>
          <Header />
          <div className="title-banner" >
            <div className="heading-one white-text bold">
              CIS Events
            </div>
          </div>
          <div className="container">
            <div className='top-contents'>
              <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /></Link><img className='rightarrow' src={crumbarrow} /><Link to='/events/upcoming' className='gray-text'>CIS Events</Link></div>
            </div>
            <div className="gloss_container">
              <div className="toggle-bar-two">
                <button onClick={() => this.goto('/events/past')} className={this.state.tab === 1 ? "bg-blue white-text" : "bg-blue no-active blue-text"}>Past Events</button>
                <button onClick={() => this.goto('/events/upcoming')} className={this.state.tab === 2 ? "bg-blue white-text" : "bg-blue no-active blue-text"}>Upcoming Events</button>
                {/* <button style={{ backgroundColor: this.state.tab === 3 ? '#165E84' : '', color: this.state.tab === 3 ? "#fff" : "" }} onClick={() => this.goto('/events/archives')}> Event Reports</button> */}
              </div>
              <div className="rows selectTag-rows">
                <div className="selectTag-container" style={{ marginRight: "1%" }}>
                  <select className="selectTag-one type-selectTag" placeholder="Type of event" onChange={(e) => this.addFilter("event_type", e.target.value)} style={{ backgroundImage: `url(${downarrow})`, width: `${this.state.event_type ? this.state.type_length : 132}px` }} >
                    <option value="" selected>Type of Event</option>
                    {
                      this.state.types ? this.state.types.map(type => {
                        return <option value={type.attributes.name} >{type.attributes.name}</option>
                      }) : ""
                    }
                  </select>
                </div>
                <div className="selectTag-container" style={{ marginRight: "1%" }}>
                  <select className="selectTag-one purpose-Selecttag" placeholder="Type of event" onChange={(e) => this.addFilter("event_purpose", e.target.value)} style={{ backgroundImage: `url(${downarrow})`, width: `${this.state.event_purpose ? this.state.purpose_length : 180}px` }} >
                    <option value="" selected>Purpose of the Event</option>
                    {
                      this.state.othertypes ? this.state.othertypes.event_purpose ? this.state.othertypes.event_purpose.map(type => {
                        return <option value={type} >{type}</option>
                      }) : "" : ''
                    }
                  </select>
                </div>
                <div className="selectTag-container" style={{ marginRight: "1%" }}>
                  <select className="selectTag-one format-selectTag" placeholder="Type of Event" onChange={(e) => this.addFilter("event_format", e.target.value)} style={{ backgroundImage: `url(${downarrow})`, width: "135px" }} >
                    <option value="" selected>Event Format</option>
                    {
                      this.state.event_format_list ? this.state.event_format_list.map(type => {
                        return <option value={type.attributes.name} >{type.attributes.name}</option>
                      }) : ""
                    }
                  </select>
                </div>
                <div className="selectTag-container">
                  <select className="selectTag-one year-selectTag" placeholder="Type of Event" onChange={(e) => this.addFilter("year", e.target.value)} style={{ backgroundImage: `url(${downarrow})` }} >
                    <option value="" selected>Year</option>
                    <option value="2022">2022</option>
                    <option value="2021">2021</option>
                    <option value="2020">2020</option>
                    <option value="2019">2019</option>
                    <option value="2018">2018</option>
                    <option value="2017">2017</option>
                    <option value="2016">2016</option>
                    <option value="2015">2015</option>
                    <option value="2014">2014</option>
                    <option value="2013">2013</option>
                    <option value="2012">2012</option>
                  </select>
                </div>
              </div>
              <div className="input-container">
                <input id="newSearchInput" className="newSearchInput" type="text" placeholder="Search " name="search" onChange={(e) => { this.setFilter(e.target.value) }} onKeyPress={(e) => this._handleKeyPress(e)} maxLength={16} />
                {/* <input type="text" placeholder="Search " name="search" onChange={(e) => { this.setFilter(e.target.value) }} onKeyPress={(e) => this._handleKeyPress(e)} /> */}
                {/* <div className="search_logo" onClick={() => this.apicallpast(this.state.search)}><img src={search} height="20px" /></div> */}
              </div>
            </div>
          </div>
          <div className="main-content">
            <div className="container">
              <div className="row">
                <div className="region region-content">
                  <div id="block-quicktabs-events" className="block block-quicktabs">


                    <div className="content">

                      <div id="quicktabs-events" className="quicktabs-wrapper quicktabs-style-nostyle">
                        <div id="quicktabs-container-events" className="quicktabs_main quicktabs-style-nostyle">
                          <div id="quicktabs-tabpage-events-0" className="quicktabs-tabpage ">
                            <div className="view view-events ">



                              <div className="view-content">
                                <div className="views-row views-row-1 views-row-odd views-row-first">


                                  {this.state.tab === 2 ? this.state.upevents ?
                                    this.state.upevents.length !== 0 ?
                                      this.state.upevents.map((event, index) => {
                                        let img = []
                                        let pdf = []
                                        const included = this.state.upinclude
                                        if (event.relationships.field_image.data) { img = included.filter(x => x.id === event.relationships.field_image.data.id) }
                                        if (event.relationships.field_event_report.data) { pdf = included.filter(x => x.id === event.relationships.field_event_report.data.id) }
                                        let date = new Date()
                                        let curdate = new Date(event.attributes.field_date)
                                        return (
                                          <div className="views-field views-field-nothing field-content">
                                            <div class="col s5 m3 l3 thumbnail">
                                              <Link to={{ pathname: '/upcoming/' + `${event.attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}/${event.attributes.drupal_internal__nid}` }}><img typeof="foaf:Image" src={img[0] ? BASE + img[0].attributes.uri.url : grey} width="176" height="220" alt="" /></Link>
                                            </div>
                                            <div className="col s7 m9 l9 area">
                                              <div className="event-heading">
                                                <Link to={{ pathname: '/upcoming/' + `${event.attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}/${event.attributes.drupal_internal__nid}` }}>
                                                  {event.attributes.title}
                                                </Link>
                                              </div>
                                              <div className='date-venue'>
                                                <div className="date">
                                                  <img src={calender} className="calendar-icon" alt='icon' />
                                                  {event.attributes.field_from_date ? <span className="date-display-range gray-text">
                                                    <span className="date-display-start" >
                                                      {console.log('events', event)}
                                                      {new Date(event.attributes.field_from_date).getDate() + '-' + parseInt(new Date(event.attributes.field_from_date).getMonth() + parseInt(1)) + '-' + new Date(event.attributes.field_from_date).getFullYear()}</span><span style={{ paddingLeft: '3px', paddingRight: '3px' }}> to</span>
                                                  </span> : ''}
                                                  <span className="date-display-range gray-text">
                                                    <span className="date-display-start" >
                                                      {new Date(event.attributes.field_date).getDate() + '-' + parseInt(new Date(event.attributes.field_date).getMonth() + parseInt(1)) + '-' + new Date(event.attributes.field_date).getFullYear() + ' '} </span>
                                                  </span>
                                                </div>
                                                <div className="venue">
                                                  <img className="location-img" src={location} alt='icon' />{event.attributes.field_venue}
                                                </div>
                                              </div>
                                              {/* {event.attributes.event_report_url ?
                                                  <div className="pdf">
                                                    <img src={eventpdf} className="pdf-icon" alt='icon' /><a target="_blank" style={{ color: '#165E84 ' }} rel="noopener noreferrer" href={BASE + event.attributes.event_report_url[0]}>Event report</a>
                                                  </div> : ''} */}
                                              <div className='date-venue'>
                                                {pdf[0] ?
                                                  <div className="date repo-vids repo-vids-pdf">
                                                    <img src={eventpdf} className="pdf-icon" alt='icon' />
                                                    <div className='vids'>
                                                      {pdf.map((data, index) =>
                                                        <a target='_blank' href={BASE + data.attributes.uri.url}>Report Download</a>
                                                      )}
                                                    </div>
                                                  </div> : ''}
                                                {event.attributes.field_youtube_link ?
                                                  <div className=" repo-vids repo-vids-pdf">
                                                    <img src={eventvideo} className="video-icon" alt='icon' />
                                                    <div className='vids'>
                                                      {event.attributes.field_youtube_link.map((data, index) =>
                                                        <a target='_blank' href={data.uri}>Event Video</a>
                                                      )}
                                                    </div>
                                                  </div> : ''}
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      }) : <div className="noevent">No Upcoming Events</div> : <List /> : ""
                                  }


                                  {this.state.tab === 1 ? this.state.pastevents ?
                                    this.state.pastevents.length !== 0 ?
                                      this.state.pastevents.map((event, index) => {
                                        let img = []
                                        let pdf = []
                                        const included = this.state.include
                                        if (event.relationships.field_image.data) { img = included.filter(x => x.id === event.relationships.field_image.data.id) }
                                        if (event.relationships.field_event_report.data) { pdf = included.filter(x => x.id === event.relationships.field_event_report.data.id) }
                                        let date = new Date()
                                        let curdate = new Date(event.attributes.field_date)
                                        if (curdate.getTime() < date.getTime())
                                          return (
                                            <div className="views-field views-field-nothing field-content">
                                              <div class="col s5 m3 l3 thumbnail">
                                                <Link to={{ pathname: '/event_desc/' + `${event.attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}/${event.attributes.drupal_internal__nid}` }}><img typeof="foaf:Image" src={img[0] ? BASE + img[0].attributes.uri.url : grey} width="176" height="220" alt="" /></Link>
                                              </div>
                                              <div className="col s7 m9 l9 area">
                                                <div className="event-heading">
                                                  <Link to={{ pathname: '/event_desc/' + `${event.attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}/${event.attributes.drupal_internal__nid}` }}>
                                                    {event.attributes.title}
                                                  </Link>
                                                </div>
                                                <div className='date-venue'>
                                                  <div className="date">
                                                    <img src={calender} className="calendar-icon" alt='icon' />
                                                    {event.attributes.field_from_date ? <span className="date-display-range gray-text">
                                                      <span className="date-display-start" >
                                                        {console.log('events', event)}
                                                        {new Date(event.attributes.field_from_date).getDate() + '-' + parseInt(new Date(event.attributes.field_from_date).getMonth() + parseInt(1)) + '-' + new Date(event.attributes.field_from_date).getFullYear()}</span><span style={{ paddingLeft: '3px', paddingRight: '3px' }}> to</span>
                                                    </span> : ''}
                                                    <span className="date-display-range gray-text">
                                                      <span className="date-display-start" >
                                                        {new Date(event.attributes.field_date).getDate() + '-' + parseInt(new Date(event.attributes.field_date).getMonth() + parseInt(1)) + '-' + new Date(event.attributes.field_date).getFullYear() + ' '} </span>
                                                    </span>
                                                  </div>
                                                  <div className="venue">
                                                    <img className="location-img" src={location} alt='icon' />{event.attributes.field_venue}
                                                  </div>
                                                </div>
                                                {/* {event.attributes.event_report_url ?
                                                  <div className="pdf">
                                                    <img src={eventpdf} className="pdf-icon" alt='icon' /><a target="_blank" style={{ color: '#165E84 ' }} rel="noopener noreferrer" href={BASE + event.attributes.event_report_url[0]}>Event report</a>
                                                  </div> : ''} */}
                                                <div className='date-venue'>
                                                  {pdf[0] ?
                                                    <div className="date repo-vids repo-vids-pdf">
                                                      <img src={eventpdf} className="pdf-icon" alt='icon' />
                                                      <div className='vids'>
                                                        {pdf.map((data, index) =>
                                                          <a target='_blank' href={BASE + data.attributes.uri.url}>Report Download</a>
                                                        )}
                                                      </div>
                                                    </div> : ''}
                                                  {event.attributes.field_youtube_link ?
                                                    <div className=" repo-vids repo-vids-pdf">
                                                      <img src={eventvideo} className="video-icon" alt='icon' />
                                                      <div className='vids'>
                                                        {event.attributes.field_youtube_link.map((data, index) =>
                                                          <a target='_blank' href={data.uri}>Event Video</a>
                                                        )}
                                                      </div>
                                                    </div> : ''}
                                                </div>
                                              </div>
                                            </div>
                                          )
                                      }) : <div className="noevent">No Past Events</div> : <List /> : ""
                                  }
                                  {/* Archive */}

                                  {/* {this.state.tab === 3 ?
                                    <div className="views-field views-field-nothing">
                                      <span className="field-content">
                                        <div class="col s12 m12 l12 thumbnail">
                                          <Archive />
                                        </div>
                                      </span>
                                    </div>
                                    : ''} */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.tab === 1 ? this.state.prevpast || this.state.nextpast ?
          <div className='new-pagination'>
            <button disabled={!this.state.prevpast} onClick={() => this.handlePageClick('prevpast')} className='prev'>{!this.state.prevpast ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetpast ? (this.state.offsetpast / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.pastcount ? Math.ceil(this.state.pastcount / 10) : 1}</div> <button disabled={!this.state.nextpast} onClick={() => this.handlePageClick('nextpast')} className='next'>{this.state.nextpast ? <img src={pageright} /> : <img src={pagenoright} />}</button>
          </div> : "" : ""}
        {/* {this.state.tab === 1 ? this.state.prevpast || this.state.nextpast ?
          <ul className="pagination">
            <li onClick={() => this.handlePageClick('prevpast')} className="previous disabled">
              <a style={{ color: this.state.prevpast ? '#165E84 ' : '', fontWeight: this.state.prevpast ? '500' : '', cursor: this.state.prevpast ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
            <li onClick={() => this.handlePageClick('nextpast')} className="next"><a style={{ color: this.state.nextpast ? '#165E84 ' : '', fontWeight: this.state.nextpast ? '500' : '', cursor: this.state.nextpast ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>
          </ul>
          : '' : ''} */}
        {this.state.tab === 2 ? this.state.prev || this.state.next ?
          <ul className="pagination">
            <li onClick={() => this.handlePageClick('prev', this.state.search)} className="previous disabled">
              <a style={{ color: this.state.prev ? '#165E84 ' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
            <li onClick={() => this.handlePageClick('next', this.state.search)} className="next"><a style={{ color: this.state.next ? '#165E84 ' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>
          </ul>
          : '' : ''}
        <div className={this.state.tab === 2 || this.state.tab === 1 ? "filterfooter nobottom" : "filterfooter"}><Footer /></div>
      </div>
    )
  }

}


export default Events;
